import axios from "axios";

const GOOGLE_OAUTH_BASE_URLS = [
    'https://accounts.google.com/o/oauth2/',
    'https://oauth2.googleapis.com/',
    'https://www.googleapis.com/oauth2/'
];

axios.interceptors.request.use(config => {
    const language = localStorage.getItem("rapidtoolz_language")
    
    const isGoogleOAuthRequest = GOOGLE_OAUTH_BASE_URLS.some(oauthUrl =>
        config.url.startsWith(oauthUrl)
    );

    // Only add the custom header if it's NOT a Google OAuth request
    if (language && !isGoogleOAuthRequest) {
        config.headers['X-RapidToolz-Language'] = language;
    }
    return config
}, error => {
    return Promise.reject(error)
})